import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

export default function Topbar({ onMenuToggle, breadcrumbContent }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [dropOpen, setDropOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button
          className="btn btn-link p-0 d-lg-none"
          onClick={onMenuToggle}
          style={{ color: '#495057', fontSize: '1.2rem' }}
        >
          <i className="bi bi-list"></i>
        </button>
        {breadcrumbContent}
      </div>

      <div className="topbar-right">
        {/* User dropdown */}
        <div className="position-relative">
          <button
            className="btn btn-link p-0 d-flex align-items-center gap-2 text-decoration-none"
            onClick={() => setDropOpen((v) => !v)}
            style={{ color: '#495057' }}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: 34, height: 34, background: '#405189', color: '#fff', fontWeight: 700 }}
            >
              {user?.name?.charAt(0).toUpperCase()}
            </div>
            <span className="d-none d-md-inline small fw-500">{user?.name}</span>
            <i className="bi bi-chevron-down small"></i>
          </button>

          {dropOpen && (
            <>
              <div
                className="position-fixed inset-0"
                style={{ zIndex: 1049 }}
                onClick={() => setDropOpen(false)}
              ></div>
              <div
                className="position-absolute end-0 mt-2 bg-white rounded shadow border p-2"
                style={{ minWidth: 180, zIndex: 1050 }}
              >
                <div className="px-3 py-2 border-bottom">
                  <div className="fw-600 small">{user?.name}</div>
                  <div className="text-muted" style={{ fontSize: '.75rem' }}>{user?.email}</div>
                </div>
                <Link to="/profile" className="dropdown-item py-2 small" onClick={() => setDropOpen(false)}>
                  <i className="bi bi-person me-2"></i>Profile
                </Link>
                <Link to="/change-password" className="dropdown-item py-2 small" onClick={() => setDropOpen(false)}>
                  <i className="bi bi-key me-2"></i>Change Password
                </Link>
                <div className="dropdown-divider"></div>
                <button className="dropdown-item py-2 small text-danger" onClick={handleLogout}>
                  <i className="bi bi-box-arrow-right me-2"></i>Logout
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
